import { rootApi } from '../rootApi';

/**
 * LMS Planlama Eğitmenleri — `/v1.0/LmsPlanningInstructor`.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 2.md §9.
 *
 * Katalog seviyesindeki eğitmen atamalarından (`LmsTrainingInstructor`) ayrıdır: atama eğitime
 * değil, o eğitimin belirli bir planlamasına yapılır. `instructorsCount`, planlamanın aktif
 * eğitmen sayısıdır ve `LmsCatalogPlanning` üzerinde değil bu tablonun kendi satırlarında
 * tutulur (doc §9.1) — bu yüzden `LmsTrainingInstructor`'ın aksine burada `LmsCatalogPlanning`
 * tag'i invalidate edilmez, yalnızca `LmsPlanningInstructor`.
 */
export const lmsPlanningInstructorApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsPlanningInstructors: builder.query({
            query: ({ planningId, trainingId, userId, userFullName, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsPlanningInstructor/GetList',
                method: 'POST',
                body: {
                    planningId: planningId ?? null,
                    trainingId: trainingId ?? null,
                    userId: userId ?? null,
                    userFullName: userFullName || null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsPlanningInstructor']
        }),

        getLmsPlanningInstructorById: builder.query({
            query: (id) => ({
                url: 'v1/LmsPlanningInstructor/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsPlanningInstructor']
        }),

        addLmsPlanningInstructor: builder.mutation({
            query: ({ planningId, userId }) => ({
                url: 'v1/LmsPlanningInstructor/Add',
                method: 'POST',
                body: { planningId, userId }
            }),
            invalidatesTags: ['LmsPlanningInstructor']
        }),

        updateLmsPlanningInstructor: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsPlanningInstructor/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsPlanningInstructor']
        }),

        deleteLmsPlanningInstructor: builder.mutation({
            query: (id) => ({
                url: `v1/LmsPlanningInstructor/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsPlanningInstructor']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsPlanningInstructorsQuery,
    useGetLmsPlanningInstructorByIdQuery,
    useAddLmsPlanningInstructorMutation,
    useUpdateLmsPlanningInstructorMutation,
    useDeleteLmsPlanningInstructorMutation
} = lmsPlanningInstructorApi;
